import { GLCodeYearDepartment } from 'src/services/useGlCodeDepartmentApi';
import { DepartmentGlCode, DepartmentMembers } from 'src/types/department';

export const formatCheckbookExcelData = (data: any[]) =>
  data.reduce((acc, item) => {
    if (item.departments.length) {
      acc = [
        ...acc,
        ...item.departments.map((department: GLCodeYearDepartment) => ({
          department: department.departmentName,
          ...item,
        })),
      ];
    } else {
      acc.push({ ...item, department: '' });
    }

    return acc;
  }, []);

export const formatGLCodesExcelData = (data: any[]) =>
  data
    .filter((dt) => !dt.isDeleted)
    .reduce((acc, item) => {
      if (item.glCodes.length) {
        acc = [
          ...acc,
          ...item.glCodes.map((glCode: DepartmentGlCode) => ({
            code: glCode.code,
            description: glCode.description,
            ...item,
          })),
        ];
      } else {
        acc.push({ ...item, code: '', description: '' });
      }
      return acc;
    }, []);

export const formatMembersExcelData = (data: any[]) =>
  data
    .filter((dt) => !dt.isDeleted)
    .reduce((acc, item) => {
      if (item.members.length) {
        acc = [
          ...acc,
          ...item.members.map((member: DepartmentMembers) => ({
            memberName: member.name,
            ...item,
          })),
        ];
      } else {
        acc.push({ ...item, memberName: '' });
      }
      return acc;
    }, []);

export const flattenMessages = (messages: Record<string, any>[]) => {
  const isPlainObject = (obj: any) => Object.prototype.toString.call(obj) === '[object Object]';

  return [
    ...Object.values(messages)
      .map((i) => Object.values(i).flat())
      .flat()
      .map((item: any) => (typeof item === 'string' || isPlainObject(item) ? item : null))
      .flat()
      .filter((item: any, i, arr) => arr.indexOf(item) === i && item !== null),
  ] as string[];
};

export const convertToTwoDigitNumber = (number: number) => {
  if (number < 10) {
    return '0' + number;
  } else {
    return number.toString();
  }
};
